import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import featureFlags, { ConfigCatSource } from '@masfront/common-feature-flags'

import { Flags } from '../model'
import { selectFeatureFlag } from '../store'

import { selectAgent } from '~/auth/store/auth.selectors'

export default function useRemoteFlagsInitAndUp() {
  const { agent } = useSelector(selectAgent)
  const isInitializedUserConfigCat = useSelector(
    selectFeatureFlag(Flags.isInitializedUserConfigCat),
  )

  useEffect(() => {
    const userObj = agent.sub
      ? {
          identifier: agent.sub,
          email: agent.sub,
        }
      : undefined

    const configCatSource = featureFlags.getSource('REMOTE_FLAGGER') as ConfigCatSource

    if (userObj) {
      configCatSource.setUser(userObj)
    }
  }, [agent])

  return {
    isInitializedAndUpRemoteFlags: isInitializedUserConfigCat,
  }
}
